import React from 'react'
import PropTypes from 'prop-types'
import Button from '@components/Button'
import { BUTTON_SIZE, BUTTON_TYPE, COLORS } from '@helpers/constants'
import Loader from '@components/Loader'

const ButtonWithLoader = (props) => {
  const {
    type,
    size = BUTTON_SIZE.LARGE,
    isLoading,
    enabledText,
    disabled,
    handleClick,
  } = props
  const disabledText = props.disabledText ?? props.enabledText

  return (
    <Button
      type={type}
      handleClick={handleClick}
      disabled={disabled || isLoading}
      textColor={COLORS.WHITE.TEXT}
      size={size}
      {...props}
    >
      {isLoading && <Loader noMargin />}
      {!isLoading && disabled && (
        <span className={'relative top-0'}>{disabledText}</span>
      )}
      {!isLoading && !disabled && (
        <span className={'relative top-0'}>{enabledText}</span>
      )}
    </Button>
  )
}

ButtonWithLoader.propTypes = {
  type: PropTypes.oneOf(Object.values(BUTTON_TYPE)),
  size: PropTypes.oneOf(Object.values(BUTTON_SIZE)),
  isLoading: PropTypes.bool,
  disabledText: PropTypes.string,
  enabledText: PropTypes.string,
  disabled: PropTypes.bool,
  handleClick: PropTypes.func,
}

export default ButtonWithLoader
